/**
 * Parses JSON:API project_types response into project types with project_templates
 * resolved from included[]. Used by ProjectTypesNav so the list bypasses Redux
 * and shows all types/versions (e.g. after login).
 *
 * Expects: { data: Array, included?: Array } where data items have
 * attributes, relationships.project_templates.data as array of { id, type }.
 */

function safeId(value) {
  if (value == null) return null;
  const n = typeof value === 'number' ? value : parseInt(value, 10);
  return Number.isNaN(n) ? null : n;
}

function safeName(attrs, inc) {
  if (attrs && attrs.name != null) return attrs.name;
  if (inc && inc.name != null) return inc.name;
  return '';
}

export function parseProjectTypesFromApiResponse(response) {
  if (!response || response.error) return [];

  const rawData = response.data;
  const data = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);
  const included = response.included || [];
  const includedByKey = {};

  included.forEach(inc => {
    const id = safeId(inc.id);
    if (id == null) return;
    const attrs = inc.attributes || {};
    const resolved = { id, name: safeName(attrs, inc), ...attrs };
    const key = (inc.type || '') + '_' + id;
    includedByKey[key] = resolved;
    if (inc.type && inc.type !== 'project_template' && String(inc.type).indexOf('project_template') !== -1) {
      includedByKey['project_template_' + id] = resolved;
    }
  });

  return data.map(item => {
    const attrs = item.attributes || item || {};
    const ptId = safeId(attrs.id != null ? attrs.id : item.id);
    const relationships = item.relationships || {};
    const pt = { ...attrs, id: ptId };
    const templatesRef = relationships.project_templates && relationships.project_templates.data;
    if (Array.isArray(templatesRef)) {
      pt.project_templates = templatesRef
        .map(ref => {
          const refId = safeId(ref.id);
          if (refId == null) return null;
          const key = (ref.type || 'project_template') + '_' + ref.id;
          const altKey = 'project_template_' + ref.id;
          const resolved = includedByKey[key] || includedByKey[altKey];
          if (resolved) {
            return {
              ...resolved,
              id: safeId(resolved.id) != null ? safeId(resolved.id) : refId,
              name: safeName(resolved, null),
            };
          }
          return { id: refId, name: '' };
        })
        .filter(t => t != null && t.id != null);
    } else {
      pt.project_templates = [];
    }
    return pt;
  });
}



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/utils/parseProjectTypesFromApi.js